import { render, staticRenderFns } from "./AlcaliStatusCard.vue?vue&type=template&id=43825a7e&scoped=true&"
import script from "./AlcaliStatusCard.vue?vue&type=script&lang=js&"
export * from "./AlcaliStatusCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43825a7e",
  null
  
)

export default component.exports